import { Injectable } from '@angular/core';
import { YattaLinkBase } from '@platform-frontend/util';
import { LinkRenderer } from 'ngx-transloco-markup';
import { LinkRendererService } from './link-renderer.service';

@Injectable()
export abstract class CallbackLinkRenderer<T extends YattaLinkBase> implements LinkRenderer<T> {
  constructor(private linkRendererService: LinkRendererService) {}

  abstract supports(link: unknown): link is T;

  render(link: T, targetElement: HTMLAnchorElement): void {
    targetElement.setAttribute('href', '#');
    targetElement.setAttribute('onclick', 'event.preventDefault()');
    this.linkRendererService.renderLinkBase(link, targetElement);
  }
}
